var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcBase24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8436_12670)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8436_12670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8748 23.7911C18.456 23.7911 23.7911 18.4653 23.7911 11.8956C23.7911 5.32582 18.456 0 11.8748 0C5.63096 0 0.508716 4.79382 0 10.8956H15.7506V12.8955H8.55459e-08C0.508716 18.9973 5.63096 23.7911 11.8748 23.7911Z",
    fill: "#0052FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8436_12670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8436_12670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBase24);
export default __webpack_public_path__ + "static/media/ic_base_24.e65e7bba4b31ad895fa27fae24659305.svg";
export { ForwardRef as ReactComponent };